import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { fmtDate } from "@/lib/roles";
import { CASE_STATUS, PURPOSE_LABELS, StatusBadge } from "@/lib/cases";
import { AppShell } from "@/components/app/AppShell";

export default function AdminCases() {
  const [status, setStatus] = useState("");
  const [rows, setRows] = useState(null);

  useEffect(() => {
    setRows(null);
    api.get(`/admin/cases?status=${status}`).then(({ data }) => setRows(data)).catch((e) => {
      toast.error(formatApiError(e));
      setRows([]);
    });
  }, [status]);

  return (
    <AppShell eyebrow="— SUPER ADMIN" title="All cases">
      <select value={status} onChange={(e) => setStatus(e.target.value)} className="h-10 rounded-md border border-gray-200 bg-white px-3 text-sm" data-testid="admin-cases-status-filter">
        <option value="">All statuses</option>
        {Object.entries(CASE_STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
      </select>
      <div className="mt-5 overflow-x-auto rounded-2xl border border-gray-200 bg-white">
        <table className="w-full min-w-[860px] text-left text-sm" data-testid="admin-cases-table">
          <thead className="border-b border-gray-200 bg-oath-bg/60 font-mono-label text-[9px] text-oath-muted">
            <tr><th className="px-4 py-3">CASE</th><th className="px-4 py-3">CLIENT</th><th className="px-4 py-3">SUBJECT</th>
              <th className="px-4 py-3">PURPOSE</th><th className="px-4 py-3">OPENED</th><th className="px-4 py-3">STATUS</th></tr>
          </thead>
          <tbody>
            {rows === null && <tr><td colSpan={6} className="px-4 py-8"><Loader2 className="h-5 w-5 animate-spin text-oath-muted" /></td></tr>}
            {rows?.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-oath-muted" data-testid="admin-cases-empty">No cases.</td></tr>}
            {rows?.map((c) => (
              <tr key={c.id} className="border-b border-gray-100 last:border-0" data-testid={`admin-case-row-${c.id}`}>
                <td className="px-4 py-3 font-mono text-xs">{c.case_number}</td>
                <td className="px-4 py-3 text-oath-ink">{c.org_name}</td>
                <td className="px-4 py-3">{c.subject.first_name} {c.subject.last_name}<div className="text-xs text-oath-secondary">{c.address.city}, {c.address.state}</div></td>
                <td className="px-4 py-3 text-oath-secondary">{PURPOSE_LABELS[c.permissible_purpose]}</td>
                <td className="px-4 py-3 font-mono text-xs text-oath-secondary">{fmtDate(c.created_at)}</td>
                <td className="px-4 py-3"><StatusBadge status={c.status} testid={`admin-case-status-${c.id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}
